/**
 * prototype-extends.js
 * プロトタイプ宣言の拡張
 */

/**
 * Stringにフォーマットメソッド追加
 * 下記の形式で文字列のパラメーターを置換する
 * '文字列{0}の{1}が・・・'.format(arg1, arg2)
 * @returns 置換文字列
 */
String.prototype.format = function () {
  let formatted = this
  for (let arg in arguments) {
    formatted = formatted.replace("{" + arg + "}", arguments[arg])
  }
  return formatted
}



// WEBPACK FOOTER //
// ./src/hrm-frontend/modules/functions/prototype-extends.js